import { Injectable, inject } from '@angular/core';
import { ApplicationService } from '../swagger-api-v1';
import { Observable, of } from 'rxjs';
import { AppConfig, BusinessModel } from 'models/app-config';
import { map, switchMap, tap } from 'rxjs/operators';
import { DeviceLicenses } from 'models/device-licenses';
import { DeviceService } from 'services/device.service';
import { APP_ROUTES } from '../../app.routes';
import { AccountService, UserRole } from 'services/account.service';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private applicationService = inject(ApplicationService);
  private deviceService = inject(DeviceService);
  private accountService = inject(AccountService);
  private cachedAppConfig: AppConfig;
  private cachedDeviceLicenses: DeviceLicenses;

  public init$(): Observable<unknown> {
    return this.applicationService.getConfigurationUsingGET2().pipe(
      map((configDTO) => AppConfig.fromDTO(configDTO)),
      tap((appConfig) => {
        this.cachedAppConfig = appConfig;
      }),
      /*
      TODO: Eagerly load device licenses on app init to avoid flickering navbar, fix this
       after M3 migration is done, since the navbar is reworked on the new feature branch
       */
      switchMap(() => this.childFeaturesEnabled$())
    );
  }

  public childFeaturesEnabled$(): Observable<boolean> {
    if (this.cachedDeviceLicenses) {
      return of(this.cachedDeviceLicenses.childCapacity > 0);
    }

    return this.deviceService.getLicenses$().pipe(
      tap((licenses) => (this.cachedDeviceLicenses = licenses)),
      map((licenses) => licenses.childCapacity > 0)
    );
  }

  // TODO: Refactor this method and how it's used after M3 migration is done
  public routeEnabled(route: string, childFeaturesEnabled: boolean): boolean {
    const routePaths = APP_ROUTES.filter((r) => !r.hidden).map((r) => r.path);
    const routes = new Map(routePaths.map((r) => [r, true]));

    routes.set('blocking-history', this.appConfig.features.blockingHistory);
    routes.set(
      'access-requests',
      (this.appConfig.businessModel === BusinessModel.B2C && childFeaturesEnabled) ||
        this.appConfig.businessModel === BusinessModel.B2B ||
        this.accountService.userRole === UserRole.MSP
    );

    return routes.get(route);
  }

  public get appConfig(): AppConfig {
    return this.cachedAppConfig;
  }
}
